import * as ngCommonHttp from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AbstractInstructionService } from '@abstract-services/instruction/1.0/instruction.abstract-service.service';
import { InstructionAPI } from '@constants/api';
import { CatalogItemType } from '@constants/catalogItem/1.0';
import { CATALOG_PAGE_SIZE_OTHER_CATALOG_ITEMS } from '@constants/pagination/1.0';
import { CatalogItem, CatalogItemResponse } from '@interfaces/catalog/1.0/catalog-item';
import { CatalogItemsService } from '@services/catalog-items/1.0/catalog-items.service';
import { PaginationService } from '@services/pagination/1.0/pagination.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InstructionService implements AbstractInstructionService {
  instructionsApiUrl;
  patchUrl = '/tce-experience-admin/catalog-entries';
  itemType = CatalogItemType.INSTRUCTION;

  constructor(
    private http: ngCommonHttp.HttpClient,
    private paginationService: PaginationService,
    private catalogItemsService: CatalogItemsService,
  ) {
    this.instructionsApiUrl = InstructionAPI.GET;
  }

  getInstructions(brandId: string): Observable<CatalogItem[]> {
    const url = this.instructionsApiUrl.replace(':tenantId', brandId);
    return this.paginationService
      .fetchAllPages(url, { pageSize: CATALOG_PAGE_SIZE_OTHER_CATALOG_ITEMS })
      .pipe(
        map((response: CatalogItemResponse) => {
          if (response && response._embedded) {
            return response._embedded.instructions;
          } else {
            return undefined;
          }
        }),
        catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
      );
  }

  save(catalogEntryId: string, instruction: Partial<CatalogItem>): Observable<any> {
    const url = `${this.patchUrl}/${catalogEntryId}`;
    const payload = {
      set: {
        ...instruction,
      },
      remove: [],
    };
    return this.http.patch(url, payload).pipe(
      tap(() => {
        this.catalogItemsService.updateItemCache(instruction, this.itemType);
      }),
      map(() => instruction),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }
}
